import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { IoAdd } from 'react-icons/io5';
import './QuietAddTrigger.css';

export interface QuietAddTriggerProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  children: ReactNode;
  icon?: ReactNode;
}

export default function QuietAddTrigger({
  children,
  icon,
  className = '',
  type = 'button',
  ...props
}: QuietAddTriggerProps) {
  return (
    <button
      type={type}
      className={`quiet-add-trigger ${className}`.trim()}
      {...props}
    >
      {icon ?? <IoAdd size={16} aria-hidden />}
      <span>{children}</span>
    </button>
  );
}
